import { WithRouterProps } from 'next/dist/client/with-router';
import { withRouter } from 'next/router';
import NProgress from 'nprogress';
import React from 'react';

const CONFIG = {
  color: '#74eeb5',
  startPosition: 0.2,
  startDelayMs: 800,
};

export interface RouterProgressBarProps extends WithRouterProps {
  className?: string;
}

class RouterProgressBarClass extends React.Component<RouterProgressBarProps> {
  timerStart: ReturnType<typeof setTimeout> | undefined;

  handleStart = () => {
    if (!this.timerStart) {
      clearTimeout(this.timerStart);
    }

    this.timerStart = setTimeout(() => {
      NProgress.set(CONFIG.startPosition);
      NProgress.start();
    }, CONFIG.startDelayMs);
  };

  handleStop = () => {
    if (this.timerStart) {
      clearTimeout(this.timerStart);
    }

    NProgress.done(true);
  };

  render() {
    return null;
  }

  componentWillUnmount() {
    if (this.timerStart) clearTimeout(this.timerStart);
    this.props.router.events.on('routeChangeStart', this.handleStart);
    this.props.router.events.on('routeChangeComplete', this.handleStop);
    this.props.router.events.on('routeChangeError', this.handleStop);
  }

  componentDidMount() {
    NProgress.configure({
      template: `<div class="bar ${this.props.className}" role="bar"><div class="peg"></div></div></div>`,
    });

    this.props.router.events.off('routeChangeStart', this.handleStart);
    this.props.router.events.off('routeChangeComplete', this.handleStop);
    this.props.router.events.off('routeChangeError', this.handleStop);
  }
}

export const RouterProgressBarComponent = withRouter(RouterProgressBarClass);
